import { Status, StatusProps } from '@insight-health-ai/roseate/components';
import { ServiceRequestStatus as ServiceRequestStatusType } from 'src/models';

type ServiceRequestStatusProps = {
  status: ServiceRequestStatusType;
  statusProps?: StatusProps;
};

const statusConfigMap: Record<
  Lowercase<ServiceRequestStatusType['status_name']>,
  {
    appearance: StatusProps['appearance'];
    label: string;
  }
> = {
  created: {
    appearance: 'neutral',
    label: 'Created',
  },
  extracting: {
    appearance: 'info',
    label: 'Extracting',
  },
  processing: {
    appearance: 'info',
    label: 'Processing',
  },
  verification_required: {
    appearance: 'warning',
    label: 'Verification Required',
  },
  scheduled: {
    appearance: 'info',
    label: 'Scheduled',
  },
  inprogress: {
    appearance: 'info',
    label: 'In Progress',
  },
  active: {
    appearance: 'success',
    label: 'Active',
  },
  pending: {
    appearance: 'warning',
    label: 'Pending',
  },
  processed: {
    appearance: 'success',
    label: 'Processed',
  },
  cancelled: {
    appearance: 'error',
    label: 'Cancelled',
  },
};

export const ServiceRequestStatus = ({
  status,
  statusProps,
}: ServiceRequestStatusProps) => {
  if (!status) {
    return null;
  }

  const statusKey = status.status_name.toLowerCase() as Lowercase<
    ServiceRequestStatusType['status_name']
  >;

  const { appearance, label } = statusConfigMap[statusKey] || {
    appearance: 'neutral',
    label: status.status_name,
  };

  return (
    <Status
      {...statusProps}
      appearance={appearance}
      label={label}
      style={{
        textTransform: 'capitalize',
      }}
    />
  );
};
